import React, { useState, useEffect } from "react";
import SummaryImage from "../SummaryImage/SummaryImage";
import "./ProductCard.scss";
import { Link, useHistory } from "react-router-dom";
import Moment from "moment-timezone";
import { useSelector } from "react-redux";
import translate from "../../../i18n/translate";
import Button from "@material-ui/core/Button";
import { activeStatus } from "../../../globalConstants";
import { useIntl } from 'react-intl';

const ProductCard = (props: any) => {
  const history = useHistory();
  const allInfo = useSelector((state: any) => state);
  const intl = useIntl();

  let activeCourseStatus = activeStatus || [{}];
  const [scheduleCourseID, setScheduleCourseID] = useState("");
  const [elevateInfo, setelevateInfo] = useState({"courseStatus" :"", "sessionsCompleted":"","courseLevel":"", "upcomingSession":""});

  const [redirectPath, setredirectPath] = useState<string | undefined>(undefined);
  const redirectToProduct = (e: any) => {
    e.preventDefault();
    if (props.redirectURL) {
      if (props.productcardclass === "recommended-card") {
        history.push(`${props.redirectURL}`);
      }
      else {
        if(props.productId === "13" && !!!sessionStorage.getItem("isDemoUser")){
          window.open(props.redirectURL, "_blank");  
        } else {
          window.open(props.redirectURL, "_self");
        }        
      }
    }
    return;
  };
  const rightClickRedirection = () => {
    setredirectPath(props.redirectURL);
  }

  const redirect_progress_url = (e: any,prodID: any) => {
    e.stopPropagation();
    history.push({
      pathname: `/progress/${prodID || ""}`,
    });
  };

  const redirect_schedule_url = (e: any) => {
    e.stopPropagation();
    history.push({
      pathname: '/schedule/' + scheduleCourseID,
    });
  }
  useEffect(()=> {
    if(!!allInfo.getLearnerDetails.data && !!allInfo.createSessionService.data && !!allInfo.tmsLearnerSessions.data && !!allInfo.getOtherTasks.data)
    {
      let soloUpdate = {...elevateInfo};
      soloUpdate.courseStatus="0";
      setelevateInfo(soloUpdate);
     if(!!allInfo.getOtherTasks.data.getLearnerTasks && allInfo.getOtherTasks.data.getLearnerTasks.filter((tasks: { status: boolean; taskid : String })=>!!!tasks.status && (tasks.taskid==="2"||tasks.taskid==="3"||tasks.taskid==="4")).length<=0)
     { 
       soloUpdate.courseStatus="1";
       soloUpdate.courseLevel = !!allInfo.getLearnerDetails.data.getLearnerInfo && !!allInfo.getLearnerDetails.data.getLearnerInfo.Level?allInfo.getLearnerDetails.data.getLearnerInfo.Level : "" ;
         let stats =allInfo.createSessionService.data.createSessionService;
         soloUpdate.sessionsCompleted = String(Number(stats.statistics.finishedSessions) + Number(stats.statistics.lostSessions)+Number(stats.statistics.upcomingSessions)) + "/" + stats.length;
         if((Number(stats.statistics.finishedSessions) + Number(stats.statistics.lostSessions) + (Number(stats.statistics.upcomingSessions))===0))
         {
         soloUpdate.courseStatus= "1";
         soloUpdate.upcomingSession="Not scheduled";
         }
         else
         {
          soloUpdate.courseStatus="2";
         if(!!!stats.statistics.upcomingSessions)
         {
         soloUpdate.upcomingSession = stats.statistics.upcomingSessions
         }
         else
         {
           let upcomingData=allInfo.tmsLearnerSessions.data.getTMSLearnerSessions.filter((data: { status: string; })=>data.status==="upcoming");
           if(!!upcomingData)
           {
           upcomingData = upcomingData.slice()
           .sort((a: any, b: any) => b.startTime - a.startTime)
           .reverse();
           upcomingData = upcomingData[0]?.startTime;
           }
           const  momentDate = Moment(Moment.unix(parseInt(upcomingData)));
           soloUpdate.upcomingSession =momentDate.format("DD MMM YYYY") +"|"+ Moment.unix(parseInt(upcomingData)).format("hh:mm A") + " "+  momentDate.tz(Moment.tz.guess()).format("z");
         }
         }
         if(Number(stats.statistics.finishedSessions) + Number(stats.statistics.lostSessions)=== Number(stats.length)){
          soloUpdate.courseStatus="3";
         }

       }
     }
    
  },[allInfo.getLearnerDetails, allInfo.createSessionService,allInfo.getOtherTasks, allInfo.tmsLearnerSessions]);
  useEffect(() => {
    if (
      !!!allInfo.tmsCourses.isLoading
    ) {
      if (!!!allInfo.tmsCourses.isFailed && !!allInfo.tmsCourses.data && allInfo.tmsCourses.data.getTMSGetCourse.length>0) {
        let activeCourseId;
        if (allInfo.tmsCourses.data.getTMSGetCourse.length > 0) {
          activeCourseId = allInfo.tmsCourses.data.getTMSGetCourse.filter(
            (course: { status: string }) => course.status == "1" || course.status == "2" || course.status == "3"
          );
          activeCourseId =
            activeCourseId.length > 0
              ? allInfo.tmsCourses.data.getTMSGetCourse[allInfo.tmsCourses.data.getTMSGetCourse.length - 1].courseId
              : "0";
        } else {
          activeCourseId = "0";
        }
        setScheduleCourseID(allInfo.tmsCourses.data.getTMSGetCourse[0].courseId);
      }
    }
  }, [allInfo.tmsCourses]);

  return (
    <a href={redirectPath} className={`ProductCardBlock ${props.productcardclass}`} onClick={redirectToProduct} onContextMenu={rightClickRedirection}>
      <div className="card_verticalContent">
        <div className="pCardBody">
          <div className="mobile-illustrations">
            <div className="product-img">
              <SummaryImage alt={props.title || ""} url={props.prodcardimage}></SummaryImage>
            </div>
            <div className="recommend-img">
              <SummaryImage alt={props.title || ""} url={props.cardimage}></SummaryImage>
            </div>
          </div>
          {(props.productId !== "20" && props.productId !== "18" && props.productId !== "13" && props.productId !== "21"&& props.productId !== "22"&& props.productId !== "23"&& props.productId !== "24"&& props.productId !== "25") &&
            <div className="pCardTitle">{props.title}</div>
          }
          {(props.productId === "20") &&
            <div className="pCardTitle">Sprint <br />Business English</div>
          }
          {(props.productId === "18") &&
            <div className="pCardTitle">Sprint <br />Business Skills</div>
          }
           {(props.productId === "21") &&
            <div className="pCardTitle">Solo  <br />Business English</div>
           }
            {(props.productId === "22") &&
            <div className="pCardTitle">Solo  <br />Business German</div>
           }
            {(props.productId === "23") &&
            <div className="pCardTitle">Solo  <br />Business French</div>
           }
            {(props.productId === "24") &&
            <div className="pCardTitle">Solo  <br />Business Spanish</div>
           }
            {(props.productId === "25") &&
            <div className="pCardTitle">Elevate  <br />Business English</div>
           }
           {(props.productId === "13") &&
            <div className="pCardTitle">Halo Intelligence</div>
           }
  {(((props.productId !== "20" && props.productId !== "18" && props.productId !== "21" && props.productId !== "22" && props.productId !== "23" && props.productId !== "24" && props.productId !== "25")) || (!!sessionStorage.getItem("isDemoUser"))|| (((!!!allInfo.currentSoloCourseDetails.data||!!allInfo.currentSoloCourseDetails.isFailed) && (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24")) || ((!!!allInfo.currentCourseDetails.data||!!allInfo.currentCourseDetails.isFailed) && (props.productId==="18" || props.productId==="20"))))   && props.summary && <div className="pCardSummary"><p>{props.summary}</p></div>
          }

          {
            ((!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data)||(elevateInfo.courseStatus!=="")||(!!!allInfo.currentSoloCourseDetails.isLoading &&!!!allInfo.currentSoloCourseDetails.isFailed && !!allInfo.currentSoloCourseDetails.data && (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24"))) && !!!sessionStorage.getItem("isDemoUser") && (
              <div>
                {
                  (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24") && allInfo.currentSoloCourseDetails.data.CourseStatus === "2" && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("courselevel")}</b>
                          <label className="active-course-label">{allInfo.currentSoloCourseDetails.data.Level || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentSoloCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                      <div className="active-course-block">
                        <div className="active-course-current-level">
                          <b>{translate("currentunit")}</b>
                          <label className="active-course-label-subskill">{allInfo.currentSoloCourseDetails.data.InProgress.SkillName || ""}</label>
                        </div>
                      </div>
                    </div>
                  )
                }
                {
                  props.productId === "20" && allInfo.currentCourseDetails.data.CourseStatus === "2" && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("courselevel")}</b>
                          <label className="active-course-label">{allInfo.currentCourseDetails.data.Level || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                      <div className="active-course-block">
                        <div className="active-course-current-level">
                          <b>{translate("currentunit")}</b>
                          <label className="active-course-label-subskill">{allInfo.currentCourseDetails.data.InProgress.SkillName || ""}</label>
                        </div>

                        {
                          allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime !== undefined ? (
                            <div className="active-course-session">
                              <b>{translate("upcomingsession")}</b>
                              <label className="active-course-label-session">{Moment.unix(allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime).format("DD MMM YYYY | hh:mm A ") + Moment.unix(allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime).tz(Moment.tz.guess()).format("z")}</label>
                            </div>
                          ) : (
                              <div className="active-course-session">
                                <b>{translate("upcomingsession")}</b>
                                {
                                   allInfo.currentCourseDetails.data.UpComingSession.Session === "Not Scheduled"  && (
                                    <label className="active-course-label">{allInfo.currentCourseDetails.data.UpComingSession.Session}</label>
                                  )}
                                {
                                  allInfo.currentCourseDetails.data.UpComingSession.Session === "No Sessions" && (
                                    <a className="active-course-schedule-label" onClick={(e: any) => redirect_schedule_url(e)}>{translate("viewschedule")}</a>
                                  )}
                              </div>
                            )
                        }
                      </div>
                    </div>
                  )
                }

                {
                  props.productId === "25" && elevateInfo.courseStatus === "2" && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("courselevel")}</b>
                          <label className="active-course-label">{elevateInfo.courseLevel || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{"In progress"}</label>
                        </div>
                      </div>
                      <div className="active-course-block">
                        <div className="active-course-current-level">
                        <b>{"Category"}</b>
                          <label className="active-course-label-subskill">{"Comprehensive"}</label>
                        </div>

                        {
                          !!elevateInfo.upcomingSession ? (
                            <div className="active-course-session">
                              <b>{translate("upcomingsession")}</b>
                              <label className="active-course-label-session">{elevateInfo.upcomingSession}</label>
                            </div>
                          ) : (
                              <div className="active-course-session">
                                <b>{translate("upcomingsession")}</b>
                                {
                                elevateInfo.sessionsCompleted==="Not scheduled"? 
                                    <label className="active-course-label">{"Not scheduled"}</label>
                                    :  <a className="active-course-schedule-label" onClick={(e: any) => redirect_schedule_url(e)}>{translate("viewschedule")}</a>
                                }
                              </div>
                            )
                        }
                      </div>
                    </div>
                  )
                }

                {
                  props.productId === "18" && allInfo.currentCourseDetails.data.CourseStatus === "2" && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("currentskills")}</b>
                          <label className="active-course-label">{allInfo.currentCourseDetails.data.InProgress.SkillName || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                      <div className="active-course-block">
                        <div className="active-course-current-level">
                          <b>{translate("currentsubskills")}</b>
                          <label className="active-course-label-subskill">{allInfo.currentCourseDetails.data.InProgress.SubSkillTitle || ""}</label>
                        </div>

                        {
                          allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime !== undefined ? (
                            <div className="active-course-session">
                              <b>{translate("upcomingsession")}</b>
                              <label className="active-course-label-session">{Moment.unix(allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime).format("DD MMM YYYY | hh:mm A ") + Moment.unix(allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime).tz(Moment.tz.guess()).format("z")}</label>
                            </div>
                          ) : (
                              <div className="active-course-session">
                                <b>{translate("upcomingsession")}</b>
                                {
                                  allInfo.currentCourseDetails.data.UpComingSession.Session === "Not Scheduled" && (
                                    <label className="active-course-label">{allInfo.currentCourseDetails.data.UpComingSession.Session}</label>
                                  )}
                                {
                                  allInfo.currentCourseDetails.data.UpComingSession.Session === "No Sessions" && (
                                    <a className="active-course-schedule-label" onClick={(e: any) => redirect_schedule_url(e)}>{translate("viewschedule")}</a>
                                  )}
                              </div>
                            )
                        }
                      </div>
                    </div>
                  )
                }
                {
                  (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24") && allInfo.currentSoloCourseDetails.data.CourseStatus === "1"  && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("courselevel")}</b>
                          <label className="active-course-label">{allInfo.currentSoloCourseDetails.data.Level || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentSoloCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                      <div className="active-course-block">
                        <div className="active-course-current-level">
                          <b>{translate("currentunit")}</b>
                          <label className="active-course-label-subskill">{allInfo.currentSoloCourseDetails.data.NotStarted.SkillName || ""}</label>
                        </div>
                      </div>
                    </div>
                  )
                }
                {
                  props.productId === "20" && allInfo.currentCourseDetails.data.CourseStatus === "1" && (allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime !== undefined || allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime !== null) && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("courselevel")}</b>
                          <label className="active-course-label">{allInfo.currentCourseDetails.data.Level || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                      <div className="active-course-block">
                        <div className="active-course-current-level">
                          <b>{translate("currentunit")}</b>
                          <label className="active-course-label-subskill">{allInfo.currentCourseDetails.data.NotStarted.SkillName || ""}</label>
                        </div>

                        {
                          allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime !== undefined ? (
                            <div className="active-course-session">
                              <b>{translate("upcomingsession")}</b>
                              <label className="active-course-label-session">{Moment.unix(allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime).format("DD MMM YYYY | hh:mm A ") + Moment.unix(allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime).tz(Moment.tz.guess()).format("z")}</label>
                            </div>
                          ) : (
                              <div className="active-course-session">
                                <b>{translate("upcomingsession")}</b>
                                {
                                  allInfo.currentCourseDetails.data.UpComingSession.Session === "Not Scheduled" && (
                                    <label className="active-course-label">{allInfo.currentCourseDetails.data.UpComingSession.Session}</label>
                                  )}
                                {
                                  allInfo.currentCourseDetails.data.UpComingSession.Session === "No Sessions" && (
                                    <a className="active-course-schedule-label" onClick={(e: any) => redirect_schedule_url(e)}>{translate("viewschedule")}</a>
                                  )}
                              </div>
                            )
                        }
                      </div>
                    </div>
                  )
                }

                {
                  props.productId === "18" && allInfo.currentCourseDetails.data.CourseStatus === "1" && (allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime !== undefined || allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime !== null) && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("currentskills")}</b>
                          <label className="active-course-label">{allInfo.currentCourseDetails.data.NotStarted.SkillName || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                      <div className="active-course-block">
                        <div className="active-course-current-level">
                          <b>{translate("currentsubskills")}</b>
                          <label className="active-course-label-subskill">{allInfo.currentCourseDetails.data.NotStarted.SubSkillTitle || ""}</label>
                        </div>

                        {
                          allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime !== undefined ? (
                            <div className="active-course-session">
                              <b>{translate("upcomingsession")}</b>
                              <label className="active-course-label-session">{Moment.unix(allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime).format("DD MMM YYYY | hh:mm A ") + Moment.unix(allInfo.currentCourseDetails.data.UpComingSession.Session.StartTime).tz(Moment.tz.guess()).format("z")}</label>
                            </div>
                          ) : (
                              <div className="active-course-session">
                                <b>{translate("upcomingsession")}</b>
                                {
                                  allInfo.currentCourseDetails.data.UpComingSession.Session === "Not Scheduled" && (
                                    <label className="active-course-label">{allInfo.currentCourseDetails.data.UpComingSession.Session}</label>
                                  )}
                                {
                                  allInfo.currentCourseDetails.data.UpComingSession.Session === "No Sessions" && (
                                    <a className="active-course-schedule-label" onClick={(e: any) => redirect_schedule_url(e)}>{translate("viewschedule")}</a>
                                  )}
                              </div>
                            )
                        }
                      </div>
                    </div>
                  )
                }

                {
                  props.productId === "20" && allInfo.currentCourseDetails.data.CourseStatus === "3" && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("courselevel")}</b>
                          <label className="active-course-label">{allInfo.currentCourseDetails.data.Level || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                    </div>
                  )
                }
                {
                  props.productId === "25" && elevateInfo.courseStatus === "3" && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("courselevel")}</b>
                          <label className="active-course-label">{elevateInfo.courseLevel || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{"Completed"}</label>
                        </div>
                      </div>
                    </div>
                  )
                }
                 {
                  (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24") && allInfo.currentSoloCourseDetails.data.CourseStatus === "3" && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentSoloCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                    </div>
                  )
                }

                {
                  props.productId === "18" && allInfo.currentCourseDetails.data.CourseStatus === "3" && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{activeCourseStatus[allInfo.currentCourseDetails.data.CourseStatus] || ""}</label>
                        </div>
                      </div>
                    </div>
                  )
                }
                 {
                  (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24") && allInfo.currentSoloCourseDetails.data.CourseStatus === "0" && (
                    <div>
                      {
                        props.summary && <div className="pCardSummary"><p>{props.summary}</p></div>
                      }
                    </div>
                  )
                }
                  {
                  props.productId === "25" && (elevateInfo.courseStatus==="0"|| (elevateInfo.courseStatus==="Not started"))  && (
                    <div>
                      {
                        props.summary && <div className="pCardSummary"><p>{props.summary}</p></div>
                      }
                    </div>
                  )
                }
                
                {
                  props.productId === "20" && allInfo.currentCourseDetails.data.CourseStatus === "0" && (
                    <div>
                      {
                        props.summary && <div className="pCardSummary"><p>{props.summary}</p></div>
                      }
                    </div>
                  )
                }
                 {
                  props.productId === "18" && allInfo.currentCourseDetails.data.CourseStatus === "0" && (
                    <div>
                      {
                        props.summary && <div className="pCardSummary"><p>{props.summary}</p></div>
                      }
                    </div>
                  )
                }
              </div>
            )
          }
                 {(((props.productId !== "20" && props.productId !== "18" && props.productId !== "21" && props.productId !== "22" && props.productId !== "23" && props.productId !== "24" && props.productId !== "25")) || (((!!!allInfo.currentSoloCourseDetails.data||!!allInfo.currentSoloCourseDetails.isFailed) && (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24")) || ((!!!allInfo.currentCourseDetails.data||!!allInfo.currentCourseDetails.isFailed) && (props.productId==="18" || props.productId==="20")))) &&
            <span>
              {(props.roundButtonText || props.flatButtonText) && (
                <div className="pCardButtonsBlock">                  
                  { props.title.props ? (<> {props.flatButtonText && <Button aria-label={`${intl.formatMessage({"id":(props.title.props.id)})}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.flatButtonText}</Button>}</>) : (<>{props.flatButtonText && <Button  color="primary" aria-label={`${props.title}`}variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.flatButtonText}</Button>}</>)                    
                  }
                </div>
              )}
            </span>
          }
          {
            (!!!allInfo.currentSoloCourseDetails.isLoading &&!!!allInfo.currentSoloCourseDetails.isFailed && !!allInfo.currentSoloCourseDetails.data) && (
              (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24") && allInfo.currentSoloCourseDetails.data.CourseStatus === "0" &&
              <span>
                {(props.roundButtonText || props.flatButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.flatButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.flatButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
          {
            (!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data) && (
              props.productId === "20" && allInfo.currentCourseDetails.data.CourseStatus === "0" &&
              <span>
                {(props.roundButtonText || props.flatButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.flatButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.flatButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
          {
            (!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data) && (
              props.productId === "18" && allInfo.currentCourseDetails.data.CourseStatus === "0" &&
              <span>
                {(props.roundButtonText || props.flatButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.flatButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.flatButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
        
          {
            (!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data) && (
              props.productId === "20" && allInfo.currentCourseDetails.data.CourseStatus === "2" &&
              <span>
                {(props.activeCourseButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
           {
            (!!!allInfo.currentSoloCourseDetails.isLoading && !!allInfo.currentSoloCourseDetails.data) && (
              (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24") && allInfo.currentSoloCourseDetails.data.CourseStatus === "2" &&
              <span>
                {(props.activeCourseButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
          {
            (!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data) && (
              props.productId === "18" && allInfo.currentCourseDetails.data.CourseStatus === "2" &&
              <span>
                {(props.activeCourseButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
          {
            (!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data) && (
              props.productId === "20" && allInfo.currentCourseDetails.data.CourseStatus === "3" &&
              <span>
                {(props.activeCourseCertificateButtonText) && !!!sessionStorage.getItem("isDemoUser") && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseCertificateButtonText && <Button aria-label={`${props.title}`} component={ Link } to={`/progress/${props.productId || ""}`} onClick={(e: any) => e.stopPropagation()} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseCertificateButtonText}</Button>}                    
                  </div>
                )}
              </span>
            )
          }
            {
            (!!!allInfo.currentSoloCourseDetails.isLoading && !!allInfo.currentSoloCourseDetails.data) && (
              (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24") && allInfo.currentSoloCourseDetails.data.CourseStatus === "3" &&
              <span>
                {(props.activeCourseCertificateButtonText) &&  !!!sessionStorage.getItem("isDemoUser") && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseCertificateButtonText && <Button aria-label={`${props.title}`} component={ Link } to={`/progress/${props.productId || ""}`} onClick={(e: any) => e.stopPropagation()} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseCertificateButtonText}</Button>}                    
                  </div>
                )}
              </span>
            )
          }
          {
            (!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data) && (
              props.productId === "18" && allInfo.currentCourseDetails.data.CourseStatus === "3" &&
              <span>
                {(props.activeCourseCertificateButtonText)  && !!!sessionStorage.getItem("isDemoUser") && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseCertificateButtonText && <Button aria-label={`${props.title}`} component={ Link } to={`/progress/${props.productId || ""}`} onClick={(e: any) => e.stopPropagation()} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseCertificateButtonText}</Button>}                    
                  </div>
                )}
              </span>
            )
          }
           {
            (
              props.productId === "25" && elevateInfo.courseStatus === "3" &&
              <span>
                {(props.activeCourseCertificateButtonText)  && !!!sessionStorage.getItem("isDemoUser") && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseCertificateButtonText && <Button aria-label={`${props.title}`} component={ Link } to={`/progress/${props.productId || ""}`} onClick={(e: any) => e.stopPropagation()} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseCertificateButtonText}</Button>}                    
                  </div>
                )}
              </span>
            )
          }
          {
            (!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data) && (
              props.productId === "20" && allInfo.currentCourseDetails.data.CourseStatus === "1" &&
              <span>
                {(props.activeCourseContinueStudyingButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
          {/* added for elevate */}
          {
                  props.productId === "25" && elevateInfo.courseStatus === "1"  && (
                    <div className="parent-active-course">
                      <div className="active-course">
                        <div className="active-course-current-level">
                          <b>{translate("courselevel")}</b>
                          <label className="active-course-label">{elevateInfo.courseLevel || ""}</label>
                        </div>
                        <div className="active-course-status">
                          <b>{translate("SessionRating_status")}</b>
                          <label className="active-course-lbl">{"Not started" || ""}</label>
                        </div>
                      </div>
                      <div className="active-course-block">
                        <div className="active-course-current-level">
                        <b>{"Category"}</b>
                          <label className="active-course-label-subskill">{"Comprehensive"}</label>
                        </div>

                        {
                            elevateInfo.upcomingSession!=="" && elevateInfo.upcomingSession!=="0" && elevateInfo.upcomingSession!=="Not Scheduled" ? (
                            <div className="active-course-session">
                              <b>{translate("upcomingsession")}</b>
                              <label className="active-course-label-session">{elevateInfo.upcomingSession}</label>
                            </div>
                          ) : (
                              <div className="active-course-session">
                                <b>{translate("upcomingsession")}</b>
                                {
                                (
                                    <a className="active-course-schedule-label" onClick={(e: any) => redirect_schedule_url(e)}>{translate("viewschedule")}</a>
                                  )}
                              </div>
                            )
                        }
                      </div>
                    </div>
                  )
                }
           {
              props.productId === "25" && elevateInfo.courseStatus === "1" &&
              <span>
                {(props.activeCourseContinueStudyingButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseButtonText}</Button>}
                  </div>
                )}
              </span>
            
          }
            {
         
         props.productId === "25" && elevateInfo.courseStatus === "0" &&
         <span>
           {(props.roundButtonText || props.flatButtonText) && (
             <div className="pCardButtonsBlock">
               {props.flatButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.flatButtonText}</Button>}
             </div>
           )}
         </span>
       
     }
     {
    
    props.productId === "25" && elevateInfo.courseStatus === "2" &&
    <span>
    {(props.activeCourseButtonText) && (
      <div className="pCardButtonsBlock">
        {props.activeCourseButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseButtonText}</Button>}
      </div>
    )}
  </span>
  
    }
           {
            (!!!allInfo.currentSoloCourseDetails.isLoading && !!allInfo.currentSoloCourseDetails.data) && (
              (props.productId === "21" ||props.productId === "22"|| props.productId === "23"||props.productId === "24") && allInfo.currentSoloCourseDetails.data.CourseStatus === "1" &&
              <span>
                {(props.activeCourseContinueStudyingButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
          {
            (!!!allInfo.currentCourseDetails.isLoading && !!allInfo.currentCourseDetails.data) && (
              props.productId === "18" && allInfo.currentCourseDetails.data.CourseStatus === "1" &&
              <span>
                {(props.activeCourseContinueStudyingButtonText) && (
                  <div className="pCardButtonsBlock">
                    {props.activeCourseButtonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.activeCourseButtonText}</Button>}
                  </div>
                )}
              </span>
            )
          }
        </div>
      </div>
      <div className="desktop-illustrations">
        <div className="product-img">
          <SummaryImage alt={props.title || ""} url={props.prodcardimage}></SummaryImage>
        </div>
        <div className="recommend-img">
          <SummaryImage alt={props.title || ""} url={props.cardimage}></SummaryImage>
        </div>
      </div>
    </a>
  );
};

export default ProductCard;
